"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SentTransaction = /*#__PURE__*/function () {
  function SentTransaction(eth, txHashPromise) {
    _classCallCheck(this, SentTransaction);

    this.eth = eth;
    this.txHashPromise = txHashPromise;
    this.blocksSinceSent = 0;
  }

  _createClass(SentTransaction, [{
    key: "getTxHash",
    value: function () {
      var _getTxHash = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.txHashPromise);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTxHash() {
        return _getTxHash.apply(this, arguments);
      }

      return getTxHash;
    }()
  }, {
    key: "getReceipt",
    value: function () {
      var _getReceipt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this = this;

        var numConfirmations,
            confirmationCallback,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                numConfirmations = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : 1;
                confirmationCallback = _args4.length > 1 ? _args4[1] : undefined;

                if (!this.receipt) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt("return", this.receipt);

              case 4:
                return _context4.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve, reject) {
                    var txHash;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.prev = 0;
                            _context3.next = 3;
                            return _this.getTxHash();

                          case 3:
                            txHash = _context3.sent;
                            _context3.next = 6;
                            return _this.eth.getTransactionReceipt(txHash);

                          case 6:
                            _this.receipt = _context3.sent;

                            if (!_this.receipt) {
                              _context3.next = 15;
                              break;
                            }

                            _context3.next = 10;
                            return _this.handleReceipt(_this.receipt);

                          case 10:
                            _this.receipt = _context3.sent;

                            if (!(numConfirmations === 1)) {
                              _context3.next = 15;
                              break;
                            }

                            if (confirmationCallback) {
                              confirmationCallback(1, _this.receipt);
                            }

                            resolve(_this.receipt);
                            return _context3.abrupt("return");

                          case 15:
                            _this.eth.subscribe('newBlockHeaders').on('data', /*#__PURE__*/function () {
                              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(blockHeader, sub) {
                                var confirmations;
                                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                  while (1) {
                                    switch (_context2.prev = _context2.next) {
                                      case 0:
                                        _context2.prev = 0;
                                        _this.blocksSinceSent++;

                                        if (_this.receipt) {
                                          _context2.next = 10;
                                          break;
                                        }

                                        _context2.next = 5;
                                        return _this.eth.getTransactionReceipt(txHash);

                                      case 5:
                                        _this.receipt = _context2.sent;

                                        if (!_this.receipt) {
                                          _context2.next = 10;
                                          break;
                                        }

                                        _context2.next = 9;
                                        return _this.handleReceipt(_this.receipt);

                                      case 9:
                                        _this.receipt = _context2.sent;

                                      case 10:
                                        if (_this.receipt) {
                                          _context2.next = 13;
                                          break;
                                        }

                                        if (_this.blocksSinceSent > 50) {
                                          sub.unsubscribe();
                                          reject(new Error('No receipt after 50 blocks.'));
                                        }

                                        return _context2.abrupt("return");

                                      case 13:
                                        confirmations = 1 + blockHeader.number - _this.receipt.blockNumber;

                                        if (confirmationCallback) {
                                          confirmationCallback(confirmations, _this.receipt);
                                        }

                                        if (confirmations >= numConfirmations) {
                                          sub.unsubscribe();
                                          resolve(_this.receipt);
                                        }

                                        _context2.next = 22;
                                        break;

                                      case 18:
                                        _context2.prev = 18;
                                        _context2.t0 = _context2["catch"](0);
                                        sub.unsubscribe();
                                        reject(_context2.t0);

                                      case 22:
                                      case "end":
                                        return _context2.stop();
                                    }
                                  }
                                }, _callee2, null, [[0, 18]]);
                              }));

                              return function (_x3, _x4) {
                                return _ref2.apply(this, arguments);
                              };
                            }()).on('error', reject);

                            _context3.next = 21;
                            break;

                          case 18:
                            _context3.prev = 18;
                            _context3.t0 = _context3["catch"](0);
                            reject(_context3.t0);

                          case 21:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, null, [[0, 18]]);
                  }));

                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getReceipt() {
        return _getReceipt.apply(this, arguments);
      }

      return getReceipt;
    }()
  }, {
    key: "handleReceipt",
    value: function () {
      var _handleReceipt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(receipt) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(receipt.status === false)) {
                  _context5.next = 2;
                  break;
                }

                throw new Error('Transaction has been reverted by the EVM.');

              case 2:
                return _context5.abrupt("return", receipt);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function handleReceipt(_x5) {
        return _handleReceipt.apply(this, arguments);
      }

      return handleReceipt;
    }()
  }]);

  return SentTransaction;
}();

exports.SentTransaction = SentTransaction;